import { render, staticRenderFns } from "./list_comment_header_group.vue?vue&type=template&id=417d9ddb&scoped=true&"
import script from "./list_comment_header_group.vue?vue&type=script&lang=js&"
export * from "./list_comment_header_group.vue?vue&type=script&lang=js&"
import style0 from "./list_comment_header_group.vue?vue&type=style&index=0&id=417d9ddb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d9ddb",
  null
  
)

export default component.exports